import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _isEqual from 'lodash/isEqual';
// TODO: Drop after implementing Popover here
import Tooltip from '@omilia/tooltip';
import TextCropper from '@omilia/text-cropper';
import styled from 'styled-components';

import ICONS from 'constants/SideBarPurge';
import './style.scss';

const ErrorMessage = styled.div`
  text-align: left;

  &:not(:last-of-type) {
    margin-bottom: 0.5rem;
  }
`;

export default class PurgeGroup extends Component {
  static propTypes = {
    category: PropTypes.arrayOf(PropTypes.object),
    name: PropTypes.string,
  };

  shouldComponentUpdate(nextProps) {
    const { category } = this.props;

    return !_isEqual(nextProps.category, category);
  }

  dropUnderscore = (name, s) => name.replace('_', s);

  renderName = ({ origin, name }) => `${origin ? `${origin}.` : ''}${name}`;

  render() {
    const { category, name } = this.props;

    return category.length > 0 ? (
      <div styleName="category-block">
        <div styleName="title pad-5-50">
          <span
            className={`icon-${ICONS[this.dropUnderscore(name, '-')]} icon`}
            title={name}
          />
          {this.dropUnderscore(name, ' ')}
        </div>
        <div styleName="pad-5-50">
          {category.map(item => (
            <div
              key={item.id}
              styleName={classnames('item', {
                'non-purgable': !item.purgable,
              })}
            >
              <div styleName="name">
                <TextCropper
                  placement="right"
                  styleName="cropper"
                  text={this.renderName(item)}
                  toolTipClassName="purge-item__cropper"
                >
                  {this.renderName(item)}
                </TextCropper>
              </div>
              {!item.purgable && (
                <div>
                  {/* TODO: Drop after implementing Popover here */}
                  {item.reasons.length > 0 && (
                    <Tooltip
                      content={
                        <React.Fragment>
                          {item.reasons.map(reason => (
                            <ErrorMessage key={reason}>{reason}</ErrorMessage>
                          ))}
                        </React.Fragment>
                      }
                      placement="right"
                    >
                      <i className="icon-warning" />
                    </Tooltip>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    ) : null;
  }
}
